<template>
  <standard
    v-if="type === `standard`"
    :id="id"
    :label="label"
    :checked="checked"
    :disabled="disabled"
    :hover="hover"
    :active="active"
    :focus="focus"
    :error-message="errorMessage"
    :help-message="helpMessage"
    :help-message-position="helpMessagePosition"
    :switch-position="switchPosition"
    @onClick="onClick($event)"
  />
  <group
    v-else
    :label="label"
    :error-message="errorMessage"
    :help-message="helpMessage"
    :switch-array="switchArray"
    @onClick="onClick($event)"
  />
</template>

<script>
// Default & Group Switch Types
import Standard from "./Standard";
import Group from "./Group";

export default {
  name: "FormSwitch",
  components: {
    Standard,
    Group,
  },
  props: {
    /**
     * @description
     * Provides type for Switch.
     * Availeble types are Standard (standard) and Group (group).
     */
    type: {
      type: String,
      validator: (val) => ["standard", "group"].includes(val),
      default: "standard",
    },
    /**
     * @description
     * Checks the Switch help message position
     * Maersk Design System CSS Supports only left and right
     */
    helpMessagePosition: {
      type: String,
      validator: (val) => ["left", "right"].includes(val),
      default: "left",
    },
    /**
     * @description
     * Provides label for Switch.
     * Applicable to Standard Switch.
     */
    label: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Provides Error Message for Switch.
     * Applicable to Group Switch.
     */
    errorMessage: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Provides focus state for Switch.
     * Applicable to Group Switch.
     */
    helpMessage: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Provides focus state for Switch.
     * Applicable to Group Switch.
     * Expected Structure
     * [
     * {
     * id: "apples",
     * name: "apples",
     * label: "Apples",
     * checked: true,
     * },
     * ...
     * ]
     */
    switchArray: {
      type: Array,
      default() {
        return [];
      },
    },
    /**
     * @description
     * Provides checked state for Switch.
     * Applicable to Standard Switch.
     */
    checked: {
      type: Boolean,
      default: true,
    },
    /**
     * @description
     * Provides disabled state for Switch.
     * Applicable to Standard Switch.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Provides hover state for Switch.
     * Applicable to Standard Switch.
     */
    hover: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Provides active state for Switch.
     * Applicable to Standard Switch.
     */
    active: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Provides focus state for Switch.
     * Applicable to Standard Switch.
     */
    focus: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: ""
    },
    switchPosition: {
      type: String,
      default: "horizontal"
    }
  },
  methods: {
    onClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>